import { render, staticRenderFns } from "./AgregarProveedor.vue?vue&type=template&id=9fdada22&"
import script from "./AgregarProveedor.vue?vue&type=script&lang=js&"
export * from "./AgregarProveedor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports